import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Modal } from './modal';
import { LapPair, Runner } from './new-timer';
import { FormatTime } from './timer';
import './edit-lap.css';


interface editLapProps {
  startTime: number,
  runners: Runner[],
  lap: LapPair,
  submit: (newRunners: Runner[]) => void,
  close: () => void
}

export function EditLap(props: editLapProps) {
  const runner = props.runners.filter((r) => r.name === props.lap.name)[0];
  const [time, setTime] = useState<number>((props.lap.lap === runner.laps.length) ? runner.stopTime - props.startTime : runner.laps[props.lap.lap].time - props.startTime);
  const [_delete, setDelete] = useState<boolean>(false);
  const [comment, setComment] = useState<string | undefined>((props.lap.lap === runner.laps.length) ? undefined : runner.laps[props.lap.lap].comment);

  function handleSubmit() {
    const newRunners = [];
    for (let runner of props.runners) {
      if (runner.name === props.lap.name) {
        if (props.lap.lap !== runner.laps.length) {
          const copy = runner;
          if (_delete) {
            copy.laps.splice(props.lap.lap, 1);
          } else {
            copy.laps.splice(props.lap.lap, 1, { time: time + props.startTime, comment: comment || '' })
          }
          newRunners.push(copy)
        } else {
          const copy = runner;
          if (_delete) {
            copy.stopTime = 0;
          } else {
            copy.stopTime = time + props.startTime;
          }
          newRunners.push(copy);
        }
      } else {
        newRunners.push(runner);
      }
    }
    props.submit(newRunners);
    props.close();
  }

  function deleteLap() {
    setDelete(!_delete);
  }

  return (
    <Modal title="Edit Lap" primaryButtonText="Save" primaryButtonClick={handleSubmit} secondaryButtonText="Cancel" secondaryButtonClick={props.close}>
      <p style={{ textAlign: 'center' }}>{'Original: ' + FormatTime((props.lap.lap === runner.laps.length) ? runner.stopTime - props.startTime : runner.laps[props.lap.lap].time - props.startTime)}</p>
      {!_delete && <TimeSpinner time={time} setTime={setTime} deleteLap={deleteLap} />}
      {comment !== undefined &&
        <>
          <p className='comment-label'>Comment</p>
          <input className='comment-input' type='text' value={comment} onChange={(e) => setComment(e.target.value)} />
          <br />
        </>
      }
    </Modal>
  )
}

interface TimeSpinnerProps {
  time: number,
  setTime: React.Dispatch<React.SetStateAction<number>>,
  deleteLap: () => void
}
function TimeSpinner(props: TimeSpinnerProps) {
  const [hours, setHours] = useState<number>(Math.floor(props.time / 3600000))
  const [minutes, setMinutes] = useState<number>(Math.floor((props.time % 3600000) / 60000))
  const [seconds, setSeconds] = useState<number>(Math.floor((props.time % 60000) / 1000))
  const [millis, setMillis] = useState<number>(Math.floor((props.time % 1000) / 10))

  useEffect(() => {
    const newTime = hours + 60000 * minutes + 1000 * seconds + millis * 10;
    props.setTime(hours + 60000 * minutes + 1000 * seconds + millis * 10)
  }, [hours, minutes, seconds, millis])


  return (
    <div className='outside'>
      <div className='num-row'>
        <div className='num-col'>
          <h1>{(minutes >= 10 ? minutes.toString() : '0' + minutes.toString())}</h1>
          <select onChange={(e: any) => setMinutes(e.target.value)}>
            {new Array(60).fill(0).map((_, i) => (
              <option selected={i === minutes} value={i.toString()}>{i}</option>
            ))}
          </select>
        </div>
        <h1>:</h1>
        <div className='num-col'>
          <h1>{(seconds >= 10 ? seconds.toString() : '0' + seconds.toString())}</h1>
          <select onChange={(e: any) => setSeconds(e.target.value)}>
            {new Array(60).fill(0).map((_, i) => (
              <option selected={i === seconds} value={i.toString()}>{i}</option>
            ))}
          </select>
        </div>
        <h1>.</h1>
        <div className='num-col'>
          <h1>{(millis / 100).toFixed(2).substring(2)}</h1>
          <select onChange={(e: any) => setMillis(e.target.value)}>
            {new Array(100).fill(0).map((_, i) => (
              <option selected={i === millis} value={i.toString()}>{i}</option>
            ))}
          </select>
        </div>
      </div>
      <button className='delete-button' onClick={props.deleteLap}>Delete Lap</button>
    </div>
  )
}

interface SpinnerProps {
  low: number,
  high: number,
  start: number
}
function Spinner(props: SpinnerProps) {
  const ref = useRef<HTMLDivElement>(null);
  const ref1 = useRef<HTMLDivElement>(null);

  const [choices, setChoices] = useState<number[]>([]);

  useEffect(() => {
    if (ref && ref.current) {
      ref?.current?.scrollIntoView();
      console.log('Scrolled')
    }
  }, [ref, choices]);

  const scrollRef = useCallback((node) => {
    node.addEventListener('scroll', (e: any) => console.log(e))
  }, [])

  useEffect(() => {
    const c = new Array(props.high - props.low + 1);
    for (let i = props.low; i <= props.high; i++) {
      c[i] = i;
    }
    setChoices(c);
  }, []);

  function test() {
    console.log(ref1?.current?.scrollHeight)
    console.log(ref.current?.clientHeight)
  }

  return (
    <>
      <button onClick={test} >a;lsdkfj</button>
      <div ref={ref1} className='spin-container'>
        {choices.map((n) => (
          <h1 id={n.toString()} className='choice' ref={n === props.start ? ref : null}>{n}</h1>
        ))}
      </div>
    </>
  )
}